
export default {
  methods: {
    back: function back() {
      window.history.back();
    }
  }
};